/**
 * @file PatientEventsListView.jsx
 * @author Fernando Ruano
 * @description Patient Events List View Page
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

// Helpers
import {
  formatDate,
  joinArrayObject,
  removeNullValuesFromObject
} from 'commons/helpers/utils';
import {
  createColumns,
  getSearchApiKeys,
  getSorterString,
  PAGE_LIMIT
} from '../helper/utils';
import DashboardDetailList from '../dashboardDetailList';

function PatientEventsListView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const [rowData, setRowData] = React.useState([]);
  const { classification, totalItems: totalItemsParams } = useParams();
  const [totalItems, setTotalItems] = useState(totalItemsParams);
  const [dataFilter, setDataFilter] = useState(null);
  const [columns, setColumns] = useState([]);
  const [filter, setFilter] = useState(null);
  const [sorter, setSorter] = useState(null);

  const { getPatientEventsListPlus } = dashboardStaffActions;

  const additionalColumns = [
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      // eslint-disable-next-line react/display-name
      render: (_, item) => {
        return (
          <div>
            <div
              className={`w-96 ${
                item?.descripcion?.length > 200 ? 'h-16' : 'h-auto'
              } overflow-y-auto`}>
              {item.descripcion}
            </div>
          </div>
        );
      }
    },
    {
      title: 'Fecha de registro',
      dataIndex: 'fecha_registro',
      ellipsis: true
    }
  ];

  const getetData = (offset, pageLimit) => {
    const pageSize = pageLimit || PAGE_LIMIT;
    const joinFilter = joinArrayObject(filter);
    const joinSorter = joinArrayObject(sorter);
    const data = {
      params: {
        tipoEventoSeleccionado: classification,
        idClinic: clinicId,
        limit: pageSize,
        offset,
        ...joinFilter,
        ...joinSorter
      }
    };
    getPatientEventsListPlus(data, (_, resp) => {
      if (resp?.data && resp.data?.totalRegistros != null) {
        const newRowData = resp?.data?.listaDetalles?.map((item) => {
          return {
            ...item,
            fecha_registro: item?.fecha_registro
              ? formatDate(item.fecha_registro)
              : ''
          };
        });
        setTotalItems(resp.data?.totalRegistros);
        setRowData(newRowData ?? []);
        setDataFilter(resp.data);
      }
    });
  };

  useEffect(() => {
    if (clinicId !== null) if (clinicId !== null) getetData(1);
  }, [clinicId]);

  useEffect(() => {
    const cols = createColumns(translate, dataFilter);
    setColumns(cols);
  }, [rowData, dataFilter]);

  const handleTableChange = (pagination, filters, sorterFilter) => {
    if (filters || sorterFilter) {
      const convertedFilters = getSearchApiKeys(
        [...columns, ...additionalColumns],
        removeNullValuesFromObject(filters)
      );
      const convertedSorts = getSorterString(sorterFilter);
      setFilter(convertedFilters);
      setSorter(convertedSorts);
    }
  };

  return (
    <DashboardDetailList
      columns={columns}
      rowData={rowData}
      totalItems={totalItems}
      additionalColumns={additionalColumns}
      onPaginationChange={getetData}
      onChange={handleTableChange}
      filter={filter}
      sorter={sorter}
    />
  );
}

/**
 * Component definition of proptypes.
 */
PatientEventsListView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getPatientEventsListPlus: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default PatientEventsListView;
